export default __webpack_public_path__ + "static/media/viet-coffee.dea089d3.png";